'use strict';
import isObject from 'lodash/isObject';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/skip';
import {buildInjector} from '../../_libs/angular-utils';
import {applyAutoFilter, ReduxList} from '../../_libs/redux-observable-list';
import {projectReduxItem} from '../../app/model/redux/projectReduxItem';
import {buildParentChannelSyncNotifier} from '../../auth/utils/redux-lists';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {sortByProperty} from '../../core-utilities/filters/filterUtils';
import {SortMethod} from '../../core-utilities/filters/SortMethod';
import {buildReduxItemListSupportEpics} from '../../core-utilities/redux/listSupportEpics';
import {PROJECT_COLLECTION} from '../domain/ProjectDomain';
import {logger} from './logger';


// load angular dependencies:
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'FirebaseUtil',
]);

export const defaultSortOptions = {
  currentMethod: SortMethod.ASCENDING.name,
  property: 'name',
};

export const defaultFilterOptions = {
  isArchived: false,
  status: {
    cancelled: true,
    has_rejections: true,
    pending: true,
    in_progress: true,
    complete: true,
  },
};

export function buildAssetProjectList(options, listConfig) {
  const matchesAutoFilter = applyAutoFilter(['name', 'identifier'], 1);

  const reduxList = new ReduxList({
    ...BASE_REDUX_LIST_OPTIONS,
    pageSize: 100,
    hasParentId: true,
    useDelete: true,
    useFiltering: true,
    useAutoFilter: true,
    useFilterOptions: true,
    useSortOptions: true,
    defaultFilterOptions,
    defaultSortOptions,
    isVisible: isItemVisible,
    applySortOptions,
    syncNotifier: buildParentChannelSyncNotifier(PROJECT_COLLECTION, 'assets', `asset-project syncNotifier`),
    logger,
    ...options,
  });

  const supportEpics = buildReduxItemListSupportEpics({
    actions: reduxList.actions,
    getState: options.getState,
    navStates: listConfig.navStates,
    reduxItem: projectReduxItem,
    logger,
  });

  reduxList.epics.addEpics(supportEpics);

  return reduxList;

  function isItemVisible(item, filterData) {
    if (!isObject(item)) return false;
    if (!matchesAutoFilter(item, filterData.filter)) return false;
    try {
      if (item.isDeleting) return false;
      if (!matchesFilterOptions(item, filterData.filterOptions)) return false;

      return true;
    } catch (err) {
      logger.error({err, item, options: filterData.filterOptions}, 'error with isItemVisible');
      return false;
    }
  }

  function matchesFilterOptions(item, options) {
    if (!options.status[item.status]) return false;
    if (!options.isArchived && item.isArchived) return false;

    return true;
  }
}

export function applySortOptions(list, sortOptions) {
  const method = SortMethod.valueOf(sortOptions.currentMethod) || SortMethod.ASCENDING;
  if (method === SortMethod.NONE) {
    return list.sort(sortByProperty('id', true));
  } else {
    return list.sort(sortByProperty(sortOptions.property, method.val, true));
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/redux/assetProjectConfig.js